"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Rectangle_1 = __importDefault(require("../../../loaders/Rectangle/Rectangle"));
require("./collectionTitleDescBlockLoader.scss");
function CollectionTitleDescBlockLoader(props) {
    return !props.isMobile ? (react_1.default.createElement("div", { id: "collection-title-desc-block-loader-web", style: {
            width: "100%",
            height: "240px",
            marginTop: "25px",
        } },
        react_1.default.createElement(Rectangle_1.default, { width: 300, height: 240, radius: 0 }))) : (react_1.default.createElement("div", { id: "collection-title-desc-block-loader-mobile", style: {
            width: "100%",
            height: "225px",
            borderRadius: "8px",
            marginTop: "25px",
        } },
        react_1.default.createElement(Rectangle_1.default, { width: 300, height: 240, radius: 0 })));
}
exports.default = CollectionTitleDescBlockLoader;
